/* 签到积分展示工具，更新时间：2026-09-04 17:58 CST。只汇总后端计算结果，前端不写死奖励规则。 */
import type { SignInDay } from '../api/pointApi';

export interface SignInPointOverview {
  earned: number;
  estimated: number;
  missed: number;
}

export function summarizeSignInPoints(days: SignInDay[]): SignInPointOverview {
  return days.reduce<SignInPointOverview>((summary, day) => {
    const amount = Number(day.pointAmount || 0);
    if (day.pointStatus === 'EARNED') summary.earned += amount;
    if (day.pointStatus === 'ESTIMATED') summary.estimated += amount;
    if (day.pointStatus === 'MISSED') summary.missed += amount;
    return summary;
  }, { earned: 0, estimated: 0, missed: 0 });
}

export function signInPointLabel(status?: SignInDay['pointStatus']) {
  if (status === 'EARNED') return '获得';
  if (status === 'ESTIMATED') return '预计';
  if (status === 'MISSED') return '错失';
  return '';
}
